import produce from 'immer';
import UserServices from 'services/UserServices';

export const baseAuth = () => ({
  isLogin: !!UserServices.getJWTAuth()?.jwt,
  sessionId: UserServices.getJWTAuth()?.jwt || '',
  isFirstLoginFailed: false,
  isSubmitting: false,
  isLogout: false,
  isLogining: false,
});

//* Get auth localStorage
export const getAuthLocalStorage = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLogining = true;
  });
};

//* Login
export const fetchLogin = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLogin = false;
    draft.isSubmitting = true;
    draft.isLogining = true;
  });
};

export const fetchLoginSuccess = (actions, state) => {
  const { payload } = actions;

  return produce({ ...state, ...payload }, (draft) => {
    draft.isLogin = true;
    draft.isSubmitting = false;
    draft.isFirstLoginFailed = false;
    draft.isLogining = false;
  });
};

export const fetchLoginFailed = (actions, state) => {
  const { error } = actions;
  return produce(state, (draft) => {
    draft.isLogin = false;
    draft.isSubmitting = false;
    draft.isFirstLoginFailed = true;
    draft.isLogining = false;
    draft.error = error;
  });
};

//* Logout
export const fetchLogout = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLogout = true;
  });
};

export const fetchLogoutSuccess = (actions, state) => {
  return produce(state, (draft) => {
    return baseAuth();
  });
};
